import { useState, useEffect } from "react";
import { FaVideo, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import PrivateCallModal from "../components/PrivateCallModal";
import NicknamePopup from "../components/NicknamePopup";
import GenderSelect from "../components/GenderSelect";
import { GetHostLists, UpdateProfileDetails, GetWalletAmount, GetNotification } from "../services/api";
import { useSelector, useDispatch } from "react-redux";
import { updateUser } from "../features/auth/authSlice";
import { setNotificationCount } from "../features/notification/notificationSlice";
import { CheckIfNullOrUndefined, getMediaUrl } from "../utils/helpers";

export default function Home({ openLogin }) {
  const navigate = useNavigate();
  const [privateCall, setPrivateCall] = useState(false);

  const user = useSelector((state) => state?.auth?.user);
  const isAuthenticated = useSelector((state) => state?.auth?.isAuthenticated);
  const loading = useSelector((state) => state?.auth?.loading);

  const [userName, setUserName] = useState("");
  const [gender, setGender] = useState(0);

  const [hostData, setHostData] = useState([]);
  const [hostCallData, setHostCallData] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    privateCall && !isAuthenticated && openLogin(true);
    if (!isAuthenticated)
      setPrivateCall(false);
  }, [privateCall, isAuthenticated]);

  useEffect(() => {

    if (loading || !isAuthenticated || !user?._id) return;

    GetWalletAmount()
      .then((res) => {
        dispatch(updateUser({
          walletBalance: res?.data?.walletBalance,
        }));
      })
      .catch((err) => {
        console.log(err)
      });

    GetNotification()
      .then((res) => {
        dispatch(setNotificationCount(res.data.length));
      })
      .catch((err) => {
        console.log(err)
      });

  }, [loading, isAuthenticated, user?._id, dispatch]);

  useEffect(() => {

    if (user !== undefined && user !== null) {
      if (user.name !== undefined)
        setUserName(user?.name);
      if (user.gender !== undefined)
        setGender(user?.gender);
    }

    GetHostLists()
      .then((res) => {
        // Handle cases where the API returns { data: [...] } or just [...]
        const data = Array.isArray(res.data) ? res.data : (Array.isArray(res?.data?.data) ? res.data.data : []);
        setHostData(data);
      })
      .catch((err) => {
        console.log(err);
      });

  }, [user?.name, user?.gender]);

  const OnNameUpdate = async (updatedName) => {
    try {
      const updateRes = await UpdateProfileDetails({
        name: updatedName
      });

      if (updateRes?.data?.user?.name) {
        dispatch(updateUser({
          name: updateRes?.data?.user?.name,
        }));

        setUserName(updateRes?.data?.user?.name);
      }
    } catch (error) {
      console.error("Failed to update name:", error);
    }
  }

  const OnGenderUpdate = async (updatedGender) => {
    try {
      const gender = updatedGender === "male" ? 1 : updatedGender === "female" ? 2 : updatedGender === "other" ? 3 : 0;

      const updateRes = await UpdateProfileDetails({
        gender: gender
      });

      if (updateRes?.data?.user?.gender) {
        dispatch(updateUser({
          gender: updateRes?.data?.user?.gender,
        }));

        setGender(updateRes?.data?.user?.gender);
      }
    } catch (error) {
      console.error("Failed to update gender:", error);
    }
  }

  return (
    <div className="min-h-screen bg-black text-white px-4 md:px-24 pt-[85px] pb-20 relative">

      {/* LIVE USERS GRID */}
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {hostData
          ?.filter((host) => host?._id !== user?._id)
          ?.map((host) => (
            <div
              key={host?._id}
              onClick={() => navigate(`/user/${host?._id}`)} // ✅ OPENS NEW PAGE
              className="relative rounded-2xl overflow-hidden bg-gray-900 cursor-pointer hover:scale-[1.02] transition"
            >

              {host?.stories?.length > 0 ? (
                <video
                  src={getMediaUrl(host?.stories[0]?.url)}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
              ) : host?.posts?.length > 0 ? (
                <img
                  src={getMediaUrl(host?.posts[0]?.url)}
                  alt={host?.name}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                />
              ) : (
                <img
                  src={getMediaUrl(host?.ppImageURL)}
                  alt={host?.name}
                  className="h-[250px] md:h-[300px] lg:h-[360px] w-full object-cover"
                />
              )}

              {/* VIDEO ICON */}
              <button
                className="absolute bottom-3 right-2 bg-red-500 p-2 rounded-full transition flex items-center justify-center"
                onClick={(e) => {
                  e.stopPropagation();   // 🚫 stops parent card click
                  setHostCallData(host);
                  setPrivateCall(true);
                }}
              >
                <FaVideo size={16} className="text-white" />
              </button>

              {/* USER INFO */}
              <div className="absolute bottom-3 left-2 bg-black/60 px-3 py-1 rounded-full flex items-center gap-1 text-s">
                <span>
                  {host?.name?.length > 5 ? host?.name?.slice(0, 5) + "..." : host?.name}, {host?.age}
                </span>
                {host?.is_verified && (
                  <FaCheckCircle size={14} className="text-blue-400" />
                )}
              </div>
            </div>
          ))}
      </div>

      {isAuthenticated && privateCall &&
        <PrivateCallModal
          onClose={() => setPrivateCall(false)}
          host={hostCallData}
        />
      }

      {
        isAuthenticated && CheckIfNullOrUndefined(userName) &&
        <NicknamePopup onContinue={(nickname) => {
          OnNameUpdate(nickname);
        }} />
      }

      {
        isAuthenticated && !gender && userName &&
        <GenderSelect
          onSubmit={(gender) => {
            OnGenderUpdate(gender);
          }}
        />
      }

    </div>
  );
}